module.exports = __webpack_public_path__ + "img/header-1.1238c089.jpg";